/**
 * Status ajakan update preferensi premium — per akun, di localStorage.
 *
 * Alur: top-up sukses → modal (Fase 3). "Pilih Aktivitas" atau simpan di
 * edit-preferensi = completed. "Nanti saja" = dismissed → mengaktifkan
 * label reminder Beranda (Fase 4) + titik premium di avatar (Fase 5).
 * Default pending = modal belum pernah diputuskan.
 */

const KEY_PREFIX = 'funpaper.premium_prompt.v1:';

export type PremiumPromptState = 'pending' | 'dismissed' | 'completed';

/**
 * Reminder Beranda tampil bila: akun premium DAN preferensi belum pernah
 * disimpan (pending — termasuk yang melewatkan modal) ATAU sempat
 * ditolak ("Nanti saja" = dismissed). Non-intrusif: satu baris teks,
 * hilang permanen setelah user menyimpan preferensi (completed).
 */
export function shouldShowPremiumReminder(opts: {
  isPremium: boolean;
  promptState: PremiumPromptState;
}): boolean {
  return opts.isPremium && opts.promptState !== 'completed';
}

export function getPremiumPromptState(accountId: number | null): PremiumPromptState {
  if (accountId === null || typeof window === 'undefined') return 'pending';
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + accountId);
    return raw === 'dismissed' || raw === 'completed' ? raw : 'pending';
  } catch {
    return 'pending';
  }
}

export function setPremiumPromptState(
  accountId: number | null,
  state: PremiumPromptState,
): void {
  if (accountId === null || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY_PREFIX + accountId, state);
  } catch {
    // localStorage disabled — pengingat hanya hidup sesi ini.
  }
}

/** Untuk tests: hapus state akun ini. */
export function __resetPremiumPromptForTests(accountId: number | null): void {
  if (accountId === null || typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY_PREFIX + accountId);
  } catch {
    // ignore
  }
}
